import { c as _c } from "react/compiler-runtime";
import { getHostedOnboardingConfigOptions, isApiError } from '@onefootprint/fetch-hosted';
import { QueryClient, useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import type { Idv2ProviderProps } from './idv2-provider';

/** Fetches the config when the host didn't pass one, with the credential it did pass, as idv's init does. */
export const useOnboardingConfig = initialValues => {
  const $ = _c(10);
  const [queryClient] = useState(_temp);
  const {
    config,
    obConfigAuth,
    initialAuthToken,
    onboardingSessionToken
  } = initialValues;
  let t0;
  let t1;
  if ($[0] !== queryClient) {
    t0 = () => {
      queryClient.mount();
      return () => queryClient.unmount();
    };
    t1 = [queryClient];
    $[0] = queryClient;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== initialAuthToken || $[4] !== obConfigAuth || $[5] !== onboardingSessionToken) {
    t2 = getHostedOnboardingConfigOptions({
      headers: obConfigAuth ?? {
        "X-Fp-Authorization": initialAuthToken || onboardingSessionToken
      }
    });
    $[3] = initialAuthToken;
    $[4] = obConfigAuth;
    $[5] = onboardingSessionToken;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = !config;
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = {
      ...t2,
      enabled: t3,
      staleTime: Infinity,
      retry: _temp2
    };
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return useQuery(t4, queryClient);
};
function _temp() {
  return new QueryClient();
}
function _temp2(failureCount, error) {
  return failureCount < 2 && !isApiError(error);
}